import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { toQueryString } from '../../shared/helpers/helpers';
import { AuthService } from '../auth.service';
import {
  CreateCategoryParams,
  GetCategoryByIdResponse,
  GetCategoryRequestParams,
  GetCategoryResponse
} from '../../pages/categories/categories.interface';
import { DeleteResponse } from '../../shared/types/api-responses.type';
import { GetCategoryListResponse } from '../../interfaces/categories.interface';


@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  private apiUrl = environment.api + '/categories';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getCategories(): Observable<GetCategoryListResponse> {
    return this.http.get<GetCategoryListResponse>(this.apiUrl).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  getCategoryService(requestParams: GetCategoryRequestParams): Observable<GetCategoryResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetCategoryResponse>(url).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  getCategoryById(id: string): Observable<GetCategoryByIdResponse> {
    return this.http.get<GetCategoryByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  deleteCategoryById(id: string): Observable<DeleteResponse> {
    return this.http.delete<DeleteResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  createCategory(userData: CreateCategoryParams): Observable<GetCategoryByIdResponse> {
    return this.http.post<GetCategoryByIdResponse>(this.apiUrl, userData).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  updateCategory(id: string, params: CreateCategoryParams): Observable<GetCategoryByIdResponse> {
    return this.http.put<GetCategoryByIdResponse>(`${this.apiUrl}/${id}`, params).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }
}
